module.exports = __webpack_public_path__ + "media/images/premium/sample-758d16565b74e39ca02236f352f2e4c4.jpg";